import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import React from "react";

const AdminHeader = () => {
  const navigate = useNavigate();

  const adminLogout = () => {
    toast.success("logged out!!!", {
      position: "top-center",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
    sessionStorage.removeItem("active-admin");
    sessionStorage.removeItem("admin-jwtToken");
    setTimeout(() => {
      window.location.reload(true);
      navigate("/home");
    }, 1200);
  };

  return (
    <>
      <ul className="navbar-nav ms-auto mb-2 mb-lg-0 me-5">
        <li className="nav-item">
          <Link
            to="/admin/inventory/dashboard"
            className="nav-link active"
            aria-current="page"
          >
            <b className="text-color">Inventory Data</b>
          </Link>
        </li>

        {/* Users Module */}
        <li className="nav-item dropdown">
          <a
            className="nav-link dropdown-toggle"
            href="#"
            id="userDropdown"
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <b className="text-color">Users</b>
          </a>
          <ul className="dropdown-menu" aria-labelledby="userDropdown">
            <li className="nav-item">
              <Link
                to="/user/supplier/register"
                className="nav-link active"
                aria-current="page"
              >
                <b className="text-color"> Register Supplier</b>
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/user/delivery/register"
                className="nav-link active"
                aria-current="page"
              >
                <b className="text-color"> Register Delivery</b>
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/admin/customer/all"
                className="nav-link active"
                aria-current="page"
              >
                <b className="text-color"> Customers</b>
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/admin/delivery/all"
                className="nav-link active"
                aria-current="page"
              >
                <b className="text-color"> Delivery Persons</b>
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/admin/supplier/all"
                className="nav-link active"
                aria-current="page"
              >
                <b className="text-color"> Suppliers</b>
              </Link>
            </li>
          </ul>
        </li>

        {/* Category Module */}
        <li className="nav-item dropdown">
          <a
            className="nav-link dropdown-toggle"
            href="#"
            id="categoryDropdown"
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <b className="text-color">Categories</b>
          </a>
          <ul className="dropdown-menu" aria-labelledby="categoryDropdown">
            <li className="nav-item">
              <Link
                to="/addcategory"
                className="nav-link active"
                aria-current="page"
              >
                <b className="text-color"> Add Category</b>
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/admin/category/all"
                className="nav-link active"
                aria-current="page"
              >
                <b className="text-color"> All Categories</b>
              </Link>
            </li>
          </ul>
        </li>

        {/* Product Module */}
        <li className="nav-item dropdown">
          <a
            className="nav-link dropdown-toggle"
            href="#"
            id="productDropdown"
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <b className="text-color">Products</b>
          </a>
          <ul className="dropdown-menu" aria-labelledby="productDropdown">
            <li className="nav-item">
              <Link
                to="/addproduct"
                className="nav-link active"
                aria-current="page"
              >
                <b className="text-color"> Add Product</b>
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/admin/product/all"
                className="nav-link active"
                aria-current="page"
              >
                <b className="text-color"> All Products</b>
              </Link>
            </li>
          </ul>
        </li>

        {/* Orders Module */}
        <li className="nav-item dropdown">
          <a
            className="nav-link dropdown-toggle"
            href="#"
            id="ordersDropdown"
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <b className="text-color">Orders</b>
          </a>
          <ul className="dropdown-menu" aria-labelledby="ordersDropdown">
            <li className="nav-item">
              <Link
                to="/user/admin/allorder"
                className="nav-link active"
                aria-current="page"
              >
                <b className="text-color"> All Orders</b>
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/user/admin/assigndelivery"
                className="nav-link active"
                aria-current="page"
              >
                <b className="text-color"> Assign Order Delivery</b>
              </Link>
            </li>
          </ul>
        </li>

        <li className="nav-item">
          <Link
            to="/admin/profile"
            className="nav-link active"
            aria-current="page"
          >
            <b className="text-color">My Profile</b>
          </Link>
        </li>

        <li className="nav-item">
          <Link
            to=""
            className="nav-link active"
            aria-current="page"
            onClick={adminLogout}
          >
            <b className="text-color">Logout</b>
          </Link>
          <ToastContainer />
        </li>
      </ul>
    </>
  );
};

export default AdminHeader;
